module.exports = __webpack_public_path__ + "media/alloy.e46cb912.mp3";